export default __webpack_public_path__ + "38125b20f0dedb9ae2046c369d232758.svg";